 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER401CULTIVATIONTECHNIQUES from '@/components/0_chapter401cultivationtechniques'
 import A_CHAPTER402INDESTRUCTIBLEYINANDYANGMERIDIAN from '@/components/1_chapter402indestructibleyinandyangmeridian'
 import A_CHAPTER403PEOPLEFROMTHELONGQUANSECT from '@/components/2_chapter403peoplefromthelongquansect'
 import A_CHAPTER404INFRONTOFTHECLEARMOONPAVILION from '@/components/3_chapter404infrontoftheclearmoonpavilion'
 import A_CHAPTER405CABINANDTHESOUNDOFTHEZITHER from '@/components/4_chapter405cabinandthesoundofthezither'
 import A_CHAPTER406RETREAT from '@/components/5_chapter406retreat'
 import A_CHAPTER407MUSTDIE from '@/components/6_chapter407mustdie'
 import A_CHAPTER408LEAVINGTHEMARTIALHOUSE from '@/components/7_chapter408leavingthemartialhouse'
 import A_CHAPTER409TORTURE from '@/components/8_chapter409torture'
 import A_CHAPTER410WHENTHEREAREDIFFICULTIES from '@/components/9_chapter410whentherearedifficulties'
 import A0_CHAPTER411HALFKINGPOSSESSION from '@/components/10_chapter411halfkingpossession'
 import A1_CHAPTER412TREASON from '@/components/11_chapter412treason'
 import A2_CHAPTER413BEHEADINGGRANDMASTER from '@/components/12_chapter413beheadinggrandmaster'
 import A3_CHAPTER414FEAROFALLRACES from '@/components/13_chapter414fearofallraces'
 import A4_CHAPTER415THREAT from '@/components/14_chapter415threat'
 import A5_CHAPTER416SECTMASTERLONGQUAN from '@/components/15_chapter416sectmasterlongquan'
 import A6_CHAPTER417CURTAINFALL from '@/components/16_chapter417curtainfall'
 import A7_CHAPTER418BACKTOBOULDERCITY from '@/components/17_chapter418backtobouldercity'
 import A8_CHAPTER419LINYUROULEFT from '@/components/18_chapter419linyurouleft'
 import A9_CHAPTER420DEPARTUREENDOFTHISVOLUME from '@/components/19_chapter420departureendofthisvolume'
 import A0_CHAPTER421DONOTFORGET from '@/components/20_chapter421donotforget'
 import A1_CHAPTER422CHINESEBANDIT from '@/components/21_chapter422chinesebandit'
 import A2_CHAPTER423SYMBOLDAOHEAVENLYALLIANCE from '@/components/22_chapter423symboldaoheavenlyalliance'
 import A3_CHAPTER424MINE from '@/components/23_chapter424mine'
 import A4_CHAPTER425TENTHOUSANDPOUNDSANDAPOUND from '@/components/24_chapter425tenthousandpoundsandapound'
 import A5_CHAPTER426SOULDEVOURINGBLOODSYMBOL from '@/components/25_chapter426souldevouringbloodsymbol'
 import A6_CHAPTER427INSTANTSYMBOL from '@/components/26_chapter427instantsymbol'
 import A7_CHAPTER428TALISMANSHOP from '@/components/27_chapter428talismanshop'
 import A8_CHAPTER429OLDMENG from '@/components/28_chapter429oldmeng'
 import A9_CHAPTER430GUESTSFROMTALISMANSHOP from '@/components/29_chapter430guestsfromtalismanshop'
 import A0_CHAPTER431MYSTERIOUSMASTER from '@/components/30_chapter431mysteriousmaster'
 import A1_CHAPTER432REPLIES from '@/components/31_chapter432replies'
 import A2_CHAPTER433QIJIJIANGJIA from '@/components/32_chapter433qijijiangjia'
 import A3_CHAPTER434YOUNGMASTER from '@/components/33_chapter434youngmaster'
 import A4_CHAPTER435MRMO from '@/components/34_chapter435mrmo'
 import A5_CHAPTER436LONGQUANSECTISNOTHING from '@/components/35_chapter436longquansectisnothing'
 import A6_CHAPTER437SOULREFININGTALISMAN from '@/components/36_chapter437soulrefiningtalisman'
 import A7_CHAPTER438ANCESTOROFJIANG from '@/components/37_chapter438ancestorofjiang'
 import A8_CHAPTER439THIRDSTAR from '@/components/38_chapter439thirdstar'
 import A9_CHAPTER440ASTHENIASEEKINGINSTRUCTION from '@/components/39_chapter440astheniaseekinginstruction'
 import A0_CHAPTER441IDENTITYGUESSING from '@/components/40_chapter441identityguessing'
 import A1_CHAPTER442LADYINBLACK from '@/components/41_chapter442ladyinblack'
 import A2_CHAPTER443BACK from '@/components/42_chapter443back'
 import A3_CHAPTER444SHOPDOWN from '@/components/43_chapter444shopdown'
 import A4_CHAPTER445DECISIONOFTHEJIANGFAMILY from '@/components/44_chapter445decisionofthejiangfamily'
 import A5_CHAPTER446CONDEMNATIONAGAINSTTHEUNIONOFSYMBOLDAO from '@/components/45_chapter446condemnationagainsttheunionofsymboldao'
 import A6_CHAPTER447CONFESSION from '@/components/46_chapter447confession'
 import A7_CHAPTER448ARRIVEATTHEDOORTOAPOLOGIZE from '@/components/47_chapter448arriveatthedoortoapologize'
 import A8_CHAPTER449TALKINGCONDITIONS from '@/components/48_chapter449talkingconditions'
 import A9_CHAPTER450ENTERINGTHETALISMANDAOALLIANCE from '@/components/49_chapter450enteringthetalismandaoalliance'
 import A0_CHAPTER451LONGQUANDIVISION from '@/components/50_chapter451longquandivision'
 import A1_CHAPTER452TOKENCRITERIA from '@/components/51_chapter452tokencriteria'
 import A2_CHAPTER453BIRTH from '@/components/52_chapter453birth'
 import A3_CHAPTER454FAREWELLSECTMASTERLONGQUAN from '@/components/53_chapter454farewellsectmasterlongquan'
 import A4_CHAPTER455JUNIORSISTERLENG from '@/components/54_chapter455juniorsisterleng'
 import A5_CHAPTER456HEMATITEFRUIT from '@/components/55_chapter456hematitefruit'
 import A6_CHAPTER457HERBAAMARYLLII from '@/components/56_chapter457herbaamaryllii'
 import A7_CHAPTER458FRUITPICKING from '@/components/57_chapter458fruitpicking'
 import A8_CHAPTER459HECAUGHTUPWITHME from '@/components/58_chapter459hecaughtupwithme'
 import A9_CHAPTER460ITWASHIM from '@/components/59_chapter460itwashim'
 import A0_CHAPTER461UNFORGETTABLESTRENGTH from '@/components/60_chapter461unforgettablestrength'
 import A1_CHAPTER462CALCULATION from '@/components/61_chapter462calculation'
 import A2_CHAPTER463NIXUEXIN from '@/components/62_chapter463nixuexin'
 import A3_CHAPTER464APPRECIATION from '@/components/63_chapter464appreciation'
 import A4_CHAPTER465SUPREMA from '@/components/64_chapter465suprema'
 import A5_CHAPTER466NINECOLOREDBLUELOTUS from '@/components/65_chapter466ninecoloredbluelotus'
 import A6_CHAPTER467VALIANTBODY from '@/components/66_chapter467valiantbody'
 import A7_CHAPTER468BLACKANDWHITEPISCES from '@/components/67_chapter468blackandwhitepisces'
 import A8_CHAPTER469LONGQUANSECTTRIAL from '@/components/68_chapter469longquansecttrial'
 import A9_CHAPTER470FINGERPRINTSOFTHEGODS from '@/components/69_chapter470fingerprintsofthegods'
 import A0_CHAPTER471DRAGONFLAMECURSE from '@/components/70_chapter471dragonflamecurse'
 import A1_CHAPTER472TRUEDRAGONPOWER from '@/components/71_chapter472truedragonpower'
 import A2_CHAPTER473WELCOMEALL from '@/components/72_chapter473welcomeall'
 import A3_CHAPTER474HOWTOEND from '@/components/73_chapter474howtoend'
 import A4_CHAPTER475RETURNTOTHEHEAVENLYCOURT from '@/components/74_chapter475returntotheheavenlycourt'
 import A5_CHAPTER476HEAVENLYABYSSANDANCIENTRACE from '@/components/75_chapter476heavenlyabyssandancientrace'
 import A6_CHAPTER477INVITATIONFROMALLRACES from '@/components/76_chapter477invitationfromallraces'
 import A7_CHAPTER478BLOODSPIRITGOLD from '@/components/77_chapter478bloodspiritgold'
 import A8_CHAPTER479PROVOCATION from '@/components/78_chapter479provocation'
 import A9_CHAPTER480SUPPRESSING from '@/components/79_chapter480suppressing'
 import A0_CHAPTER481BREAKTHROUGHAGAIN from '@/components/80_chapter481breakthroughagain'
 import A1_CHAPTER482DRAGONSNAKESOCIETY from '@/components/81_chapter482dragonsnakesociety'
 import A2_CHAPTER483SEAT from '@/components/82_chapter483seat'
 import A3_CHAPTER484UNQUALIFIED from '@/components/83_chapter484unqualified'
 import A4_CHAPTER485HANDOVERTHEQUOTA from '@/components/84_chapter485handoverthequota'
 import A5_CHAPTER486XUEYANG from '@/components/85_chapter486xueyang'
 import A6_CHAPTER487THEAPPEARANCEOFTHECRANEYIMING from '@/components/86_chapter487theappearanceofthecraneyiming'
 import A7_CHAPTER488ANCIENTDIVINEPHOENIXTECHNIQUE from '@/components/87_chapter488ancientdivinephoenixtechnique'
 import A8_CHAPTER489EARLYFOGPOWDER from '@/components/88_chapter489earlyfogpowder'
 import A9_CHAPTER490UNFILIALSON from '@/components/89_chapter490unfilialson'
 import A0_CHAPTER491KINGSFIRSTAPPEARANCE from '@/components/90_chapter491kingsfirstappearance'
 import A1_CHAPTER492STONEFLAMEKING from '@/components/91_chapter492stoneflameking'
 import A2_CHAPTER493XIAOZHAN from '@/components/92_chapter493xiaozhan'
 import A3_CHAPTER494SIXKILLINGCURSES from '@/components/93_chapter494sixkillingcurses'
 import A4_CHAPTER495BURNINGSKY from '@/components/94_chapter495burningsky'
 import A5_CHAPTER496OPPRESSION from '@/components/95_chapter496oppression'
 import A6_CHAPTER497FEDERATION from '@/components/96_chapter497federation'
 import A7_CHAPTER498BROTHERMO from '@/components/97_chapter498brothermo'
 import A8_CHAPTER499WOUND from '@/components/98_chapter499wound'
 import A9_CHAPTER500SPIRITEARTH from '@/components/99_chapter500spiritearth'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter401cultivationtechniques",
 			"name" : "0_chapter401cultivationtechniques",
 			"component" : A_CHAPTER401CULTIVATIONTECHNIQUES
 		},
 		{
 			"path" : "/1_chapter402indestructibleyinandyangmeridian",
 			"name" : "1_chapter402indestructibleyinandyangmeridian",
 			"component" : A_CHAPTER402INDESTRUCTIBLEYINANDYANGMERIDIAN
 		},
 		{
 			"path" : "/2_chapter403peoplefromthelongquansect",
 			"name" : "2_chapter403peoplefromthelongquansect",
 			"component" : A_CHAPTER403PEOPLEFROMTHELONGQUANSECT
 		},
 		{
 			"path" : "/3_chapter404infrontoftheclearmoonpavilion",
 			"name" : "3_chapter404infrontoftheclearmoonpavilion",
 			"component" : A_CHAPTER404INFRONTOFTHECLEARMOONPAVILION
 		},
 		{
 			"path" : "/4_chapter405cabinandthesoundofthezither",
 			"name" : "4_chapter405cabinandthesoundofthezither",
 			"component" : A_CHAPTER405CABINANDTHESOUNDOFTHEZITHER
 		},
 		{
 			"path" : "/5_chapter406retreat",
 			"name" : "5_chapter406retreat",
 			"component" : A_CHAPTER406RETREAT
 		},
 		{
 			"path" : "/6_chapter407mustdie",
 			"name" : "6_chapter407mustdie",
 			"component" : A_CHAPTER407MUSTDIE
 		},
 		{
 			"path" : "/7_chapter408leavingthemartialhouse",
 			"name" : "7_chapter408leavingthemartialhouse",
 			"component" : A_CHAPTER408LEAVINGTHEMARTIALHOUSE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js